import { createActionsHook } from 'src/lib/sweetState';

import { GenerationResultStore } from './GenerationResultStore';

export const useGenerationResultActions = createActionsHook(GenerationResultStore);
